<template>
  <vs-button color="success" type="filled" @click="compute" :disabled="disabled">
    {{disabled ? 'Przeliczanie Wykonane' : 'Przelicz klauzule'}}
  </vs-button>
</template>

<script>

  import { EVENT_REFRESH_SEARCHES, EventBus } from '../../utils/EventBus';

  export default {
    name: "ComputeClausesButton",
    props: {
      id: {
        type: String,
        required: true
      },
      bank: {
        type: String,
        required: true
      }
    },
    mounted() {
      this.compute()
    },
    data() {
      return {
        disabled: false
      }
    },
    methods: {
      async compute() {
        this.disabled = true;
        EventBus.$emit(EVENT_REFRESH_SEARCHES);
      }
    }
  }
</script>

<style scoped>

</style>
